import { render, staticRenderFns } from "./seller-register.vue?vue&type=template&id=23e7e3e0&scoped=true&"
import script from "./seller-register.vue?vue&type=script&lang=js&"
export * from "./seller-register.vue?vue&type=script&lang=js&"
import style0 from "./seller-register.vue?vue&type=style&index=0&id=23e7e3e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e7e3e0",
  null
  
)

export default component.exports